import * as urls from '../routePaths';
import * as consts from './const';

export const getLoginUrl = (redirectPath: string): string => {
  return `${urls.LOGIN_URL}?${consts.REDIRECT_PARAM}=${encodeURIComponent(`${redirectPath}`)}`;
};
